import Vue from "vue";
import VueRouter from "vue-router";
import Antd from "ant-design-vue";

import SiteConfig from 'site-config';
import "./index.less";

import "./directives";
import App from "./App.vue";
import { initRouter, destroyRouter } from "./router";

import AntModal from "./core/Cmn/AntModal";
import EventPlugin from "./eventPlugin";
import { addGlobalUncaughtErrorHandler } from "qiankun";

import Cmn from "Cmn";
import CmnMis from 'CmnMis';
import { version as Version, name as Name } from '../package.json';

Cmn.Version[Name] = Version;

Cmn.Modal = AntModal;
const store = CmnMis.Store;

Vue.use(EventPlugin);
Vue.use(Antd);

Vue.config.productionTip = false;

let _Vue = null;

const render = (props) => {
  const router = new VueRouter({
    mode: "hash",
    base: props?.base || process.env.BASE_URL || "",
    routes: [],
  });
  
  initRouter(router, props?.base);
  const instance = new (_Vue || Vue)({
    router,
    store,
    render: (h) => h(App),
    destroyed() {
      destroyRouter();
    },
  }).$mount(props?.container?.querySelector("#app") ?? "#app");
  return {
    router,
    instance,
  };
};

if (__MAIN_SYSTEM__) {
  render();
  addGlobalUncaughtErrorHandler((...args) => {
    console.error("GlobalUncaughtErrorHandler", ...args);
  });
}

let instance = null;
let router = null;

export async function bootstrap() {
  store.commit("SetSubsys", true);
}

export async function mount(props) {
  
  SiteConfig.SysInfo = props.sysInfo || null;
  SiteConfig.SysList = props.sysList || [];
  _Vue = props.Vue;
  
  CmnMis.Frame.Parent = props.Frame;

  let { instance: instc, router: rtr } = render(props);
  instance = instc;
  router = rtr;

  instance.qiankunProps = props;
  Vue.qiankunProps = props;
  if (_Vue) {
    _Vue.qiankunProps = props;
  }

  instance.CmnMis = CmnMis;

}

export async function unmount(props) {
  instance.$once("hook:destroyed", () => {
    // 防止销毁时也用过qiankunProps
    Reflect.deleteProperty(instance, "qiankunProps");
    router = null;
    instance = null;
    _Vue = null;
  });
  instance.$destroy();
}
